import { render, staticRenderFns } from "./date-wise-expenses.vue?vue&type=template&id=1b002dff&"
import script from "./date-wise-expenses.vue?vue&type=script&lang=js&"
export * from "./date-wise-expenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports